<template>
  <div id="app">
    <router-view />
    <div class="mark" v-if="modelLogin">
      <div class="login">
        <login></login>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/views/login/model/index.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Login,
  },
  name: "App",
  computed: {
    ...mapState("app", ["modelLogin"]),
  },
  mounted() {
    // 2026-10-22 BUG-04 修复（token 失效被静默恢复，回归项 F-032）：移除 beforeunload 里的
    // store.commit("app/SET_INIT_PERMISSION", false)。
    // 根因：vuex-persistedstate 对「每一次 mutation」同步回写 localStorage（reducer 只存
    // user 模块），刷新/关闭瞬间这条 commit 会把内存中「仍有效的旧 token」原样写回
    // localStorage，覆盖掉任何已失效的 token —— 于是刷新后拿到有效 token、零 401、
    // 无提示不登出，会话被"静默恢复"。且 app 模块本就不在持久化 reducer 里
    // （store/index.js 只存 user），刷新启动时 init_permission 恒为 false，
    // 这条 commit 对下次启动没有任何实际效果；登出路径 user/logout action 内已显式
    // commit SET_INIT_PERMISSION false，登出行为不受本次移除影响。
  },
};
</script>
<style lang="scss" scoped>
#app {
  position: relative;
  .mark {
    position: absolute;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.3);
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .login {
      position: absolute;
      width: 25%;
    }
  }
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
